export default __webpack_public_path__ + "assets/webgl/intro_2.92c6e73e.png";